import img1 from "./img/tictac.gif";
import img2 from "./img/notes.PNG";
import thirdi from "./img/Thirdi .png";
import evhub from "./img/EVHub.jpg";
import cts from "./img/cts.jpg";
import nptel from "./img/NPTEL JAVA.jpeg";
import c from "./img/Introduction To Programming In C.jpg";
import icom from "./img/icom.png"
import chat from "./img/Chatting.png"
import cricket from "./img/Intra Cricket Tournament.jpg"

export const project = [
  
  {
    name: "EVHub",
    img: evhub,
    describe: " This iOS app assists users in discovering nearby charging stations, reserving slots, and enables station owners to add hubs to the map. It also ensures secure authentication for both station owners and public users.",
    slink: "https://github.com/pradeepkumar24rk/i-community",
    demo: "https://www.linkedin.com/posts/pradeepkumar-r-520520202_evhubapp-evcharging-innovation-activity-7124746102658011136-9-h5?utm_source=share&utm_medium=member_desktop",
  },
  {
    name: "Nothing's New",
    img: icom,
    describe: "Its dynamic website allows users to post blogs, share knowledge, search for blogs, message others, collaborate on a whiteboard, and follow other users. Users can save and share their favorite content, like and comment on posts, and ensure secure authentication.",
    slink: "https://github.com/pradeepkumar24rk/i-community",
    demo: "https://nothingsnew.netlify.app",
  },
  {
    name: "Chat Application",
    img: chat,
    describe: "The site enables team members to communicate via socket.io. Its interface is built with reactjs and styled components for seamless user experience and interaction.",
    slink: "https://github.com/pradeepkumar24rk/Chatting",
    demo: "https://teamchat24rk.netlify.app/",
  },
  {
    name: "Third i",
    img: thirdi,
    describe: "This landing website help to discover and download the third i application utilizes Deep Learning to implement the concept of Obstacles Detection and Distance Estimation, providing a convenient and reliable guidance system for the visually impaired.",
    slink: "https://github.com/pradeepkumar24rk/Third_i",
    demo: "https://thirdi.netlify.app/",
  },
  {
    name: "TicTacToe",
    img: img1,
    describe: "A tic tac toe game built using React JS, which allows two players to take turns marking X's and O's on a 3x3 grid. The game determines the winner based on the player who is first to get three of their marks in a row, column, or diagonal.",
    slink: "https://github.com/pradeepkumar24rk/TicTac",
    demo: "https://tictactoe24rk.netlify.app/",
  },
  {
    name: "Ocean Notes",
    img: img2,
    describe: "This website allows users to securely store and access their important notes through a personalized login system implemented with PHP. Users can easily log in and out of their account, ensuring the safety and privacy of their notes.",
    slink: "https://github.com/pradeepkumar24rk/Ocean-Notes",
    demo: "",
  },
];

export const achievementImg = [
  {
    img: cts,
  },
  {
    img: nptel,
  },
  {
    img: c,
  },
  {
    img: cricket,
  },
];

export const intenship = [
  {
    title: "MALLOW TECHNOLOGIES",
    desc: "Contributed to the design, development, and implementation of applications. Learned Swift, and Git, and completed projects including a to-do list app, a contact list app, and a movies app.",
    date: "Aug 2023 - Nov 2023",
  },
  {
    title: "INTERDECCAAN SOLUTIONS",
    desc: "I had the chance to work on a variety of initiatives throughout my time there, with a particular emphasis on the creation and ongoing upkeep of the corporate website. With the help of this experience, I was able to advance my knowledge of React.js, an excellent JavaScript package known for its component-based design and efficiency in creating dynamic user interfaces.",
    date: "May 2022 - Aug 2022",
  },
  {
    title: "MKCS DIGITTECH SOLUTIONS",
    desc: "Received certification from MKCSDIGITAL upon completing the internship. Gained hands-on experience in HTML, CSS, JS web development, website flow, full-stack development, deployment, and other essential web development skills.",
    date: "Apr 2022 - Apr 2022",
  },
];
